export default __webpack_public_path__ + "static/media/AccountSelectorCheckbox.05dc8300.svg";